import { useContext } from 'react';
import { ImagesContext } from '../providers/ImagesContext/imagesContext';

export default name => useContext(ImagesContext)(name);
